import React from "react";

const Ussd = () => {
  return <div>Ussd</div>;
};

export default Ussd;
